export default function MessageIcon() {
  return (
    <span className="w-6 flex justify-center">
      <svg
        width="18"
        height="16"
        viewBox="0 0 18 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.47564 11.3747C6.82498 12.3618 7.47166 13.2163 8.32666 13.8206C9.18166 14.425 10.203 14.7495 11.25 14.7495H15.8906C16.0025 14.7495 16.1098 14.7051 16.1889 14.626C16.2681 14.5468 16.3125 14.4395 16.3125 14.3276V9.687C16.3125 8.39222 15.8164 7.14666 14.9262 6.20642C14.036 5.26618 12.8195 4.70273 11.5266 4.63194M6.75001 11.3745H2.10938C1.99749 11.3745 1.89018 11.3301 1.81106 11.2509C1.73195 11.1718 1.6875 11.0645 1.6875 10.9526V6.312C1.6875 4.96934 2.22087 3.68168 3.17027 2.73228C4.11967 1.78288 5.40733 1.24951 6.74999 1.24951C8.09265 1.24951 9.38032 1.78288 10.3297 2.73228C11.2791 3.68169 11.8125 4.96935 11.8125 6.31201C11.8125 7.65467 11.2791 8.94234 10.3297 9.89174C9.38033 10.8411 8.09267 11.3745 6.75001 11.3745Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
